import React from "react";
import video from "./assests/video-1.mp4";
import Banner from "./components/Banner";
import Card from "./components/Card";
import beach from "./assests/beach.png";
import desert from "./assests/desert.png";
import mountains from "./assests/mountains.png";
import ocean from "./assests/ocean.png";
import waterfall from "./assests/waterfall.png";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div>
      <Banner
        btype="video"
        src={video}
        heading="PACK YOUR BAGS"
        subheading="What are you waiting for ?"
        showButton = "true"
      />
      <h2 className="text-center my-5 card-sec-head">Check out these EPIC Destinations!</h2>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-10 mx-auto ">
            <div className="row align-items-center justify-content-center">
              <div className=" col-md-4 col-sm ">
                <Card
                  path="/services"
                  img={beach}
                  title="Travel through the Islands of Bali in a Private Cruise "
                  
                />
              </div>
              <div className=" col-md-4 col-sm">
                <Card
                  path="/services"
                  img={desert}
                  title="Ride through the Sahara Desert on a guided camel tour"
                />
              </div>
              <div className=" col-md-4 col-sm ">
                <Card
                  path="/services"
                  img={mountains}
                  title="Experienc the air on top of the mountians"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ">
        <div className="row">
          <div className="col-10 mx-auto">
            <div className="row justify-content-center">
              <div className="col-md-4 col-sm">
                <Card
                  path="/services"
                  img={ocean}
                  title="Set sail in the Atlantic Ocean visiting Uncharted waters"
                />
              </div>
              <div className="col-md-4 col-sm">
                <Card
                  path="/services"
                  img={waterfall}
                  title="Explore hidden waterfall deep inside the Amazon jungle"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
